<template>
  <div :class="name">
    <skeleton-basic width="480px" height="34px" />
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';
const name = 'ttam-creative-name-skeleton';
export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    return {
      name,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-creative-name-skeleton';
.#{$name} {
}
</style>
